import { Link } from "react-router-dom";
import { ImageCarouselMobileDto } from "../../../../models/Home.model"
import { pathImages, pathPDF } from "../../../../routes/endpoints";

export const ImageCarouselMobile = (props: ImageCarouselMobileDto) => {
  const { images } = props;

  return (
    <div className="row ocultarBanMovil" role="article" aria-label="sitio de interés">
      <div className="col-12 px-0">

        <div id="BanMovile" className="carousel slide">
          <div className="carousel-inner">
            {images?.map(({ id, imagen, url, archivo, titulo }, i) => (
              <div key={id} className={`carousel-item ${i === 0 ? "active" : ""}`}>
                {url || archivo ?
                  <Link to={url || `${pathPDF}${archivo}`} target="_blank" role="link" aria-label={`${titulo}`}>
                    <img src={`${pathImages}${imagen}`} alt="" className="img-ban-responsivo-1" />
                  </Link>
                  :
                  <img src={`${pathImages}${imagen}`} alt="" className="img-ban-responsivo-1" />
                }
              </div>
            ))}
          </div>
          <button className="carousel-control-prev" type="button" data-bs-target="#BanMovile" data-bs-slide="prev" role="button" aria-label="imagen anterior">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#BanMovile" data-bs-slide="next" role="button" aria-label="imagen siguiente">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>

      </div>
    </div>
  )
}
